/**
 * 目录生成进度日志组件
 */
import React from 'react';

interface OutlineProgressLogProps {
  logs: string[];
  isGenerating: boolean;
  label: string;
  bgColor?: string;
  borderColor?: string;
  titleColor?: string;
}

const OutlineProgressLog: React.FC<OutlineProgressLogProps> = ({
  logs,
  isGenerating,
  label,
  bgColor = 'bg-blue-50',
  borderColor = 'border-blue-200',
  titleColor = 'text-blue-800',
}) => {
  if (logs.length === 0) return null;

  return (
    <div className={`mt-4 p-4 ${bgColor} border ${borderColor} rounded-md`}>
      <h4 className={`text-sm font-medium ${titleColor} mb-2`}>
        {isGenerating ? `正在生成${label}...` : `本次${label}生成过程`}
      </h4>
      <div className="bg-white p-3 rounded border max-h-48 overflow-y-auto">
        <div className="space-y-2 text-xs text-gray-700">
          {logs.map((log, index) => (
            <p key={`${index}-${log}`} className="whitespace-pre-wrap leading-5">
              {log}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OutlineProgressLog;
